export default "__VITE_ASSET__DmRiFV6X__"